import React, { useState, useEffect, useContext } from 'react'
import {
  Box,
  Heading,
  SimpleGrid,
  ScaleFade,
  Spinner,
  Show
} from '@chakra-ui/react'
import EmptyCards from '../EmptyCards'
import Info from './Info'
import Category from './Category'
import Reward from './Reward'
import FooterCard from './Footer'
import BackgroundImage from './BackgroundImage'
import { viewPromotionDataLayer } from '../../utils/gtmDatalayer'
import { groupByBusiness } from '../../utils/groupByBusiness'
import { MainContext } from '../../context'

const CardsLayout = ({
  offersData,
  accentColor,
  currentPage,
  pagesTotal,
  handlePagination,
  fontFamily,
  isLoading,
  lang,
  skin,
  dictionary,
  setSearchName
}) => {
  const setOverlay = useState(false)
  const setCurrentSocial = useState()
  const setCurrentWeb = useState()
  const [dataLayer, setDataLayer] = useState({ attemps: 0, data: [] })
  const setModalType = useState('')

  const { setFilters, filters } = useContext(MainContext)

  // Pushing dataLayer for view promotion
  useEffect(() => {
    if (dataLayer.attemps === 1) {
      viewPromotionDataLayer(dataLayer.data, dictionary, skin)
    }
  }, [dataLayer])

  useEffect(() => {
    if (dataLayer.attemps === 0 && offersData.length > 0) {
      setDataLayer({ attemps: 1, data: offersData })
    }
    return () => {
      setDataLayer({ attemps: 0, data: [] })
    }
  }, [offersData])

  /*   const handleMoreItems = () => {
    if (currentPage < pagesTotal) {
      handlePagination(currentPage + 1)
    }
  } */

  const handleLessItems = () => {
    if (currentPage > 1) {
      handlePagination(currentPage - 1)
    }
  }

  const obtainGreatestCashback = (businessData) => {
    const cashback = businessData.map((item) => parseInt(item.dv_cashback))
    return Math.max(...cashback)
  }

  const renderContent = () => {
    return (
      <Box w='100%' display='flex' flexDirection='row'>
        {skin === 'COPPEL' && (
          <Show above='lg'>
            <Box
              alignSelf='center'
              display={['none', 'block']}
              onClick={() => handleLessItems()}
              cursor='pointer'
              paddingRight='74px'
            >
              {/*
               ---- Old coppel icon "prev page" icon
              <img
                src='https://drive.google.com/uc?export=view&id=1r1fSyR7ywcXEj8LJwItaW8Cs-tFdH9Nh'
                alt='leftArrow'
                width='26px'
                height='87'
              /> */}
            </Box>
          </Show>
        )}
        <Box w='100%' display='flex' flexDirection='column'>
          <SimpleGrid columns={[1, 1, 2, 2, 3]} spacingX='20px' spacingY='20px'>
            {Object.entries(groupByBusiness(offersData)).map(([key, value]) => (
              <ScaleFade key={key} initialScale={0} in>
                <Box
                  shadow={
                    skin === 'REWORTH' || skin === undefined || skin === ''
                      ? '2px 3px 4px #2E58FF4D'
                      : skin === 'INVEX'
                      ? '2px 3px 4px #585A5F33'
                      : skin === 'FINSUS'
                      ? '2px 3px 4px #585A5F33'
                      : skin === 'UNIQ'
                      ? '2px 2px 3px 0px rgba(88, 90, 95, 0.20), -1px 0px 4px 0px rgba(88, 90, 95, 0.20)'
                      : skin === 'LIVERPOOL'
                      ? '0px 2px 4px -2px rgba(0, 0, 0, 0.24)'
                      : skin === 'SUBURBIA'
                      ? '0px 2px 4px -2px rgba(0, 0, 0, 0.24)'
                      : skin === 'ALBO'
                      ? '0px 3px 6px 0px rgba(0, 0, 0, 0.12)'
                      : null
                  }

                  bgImage={
                    skin === 'REWORTH' || skin === undefined || skin === ''
                      ? 'linear-gradient(288deg, #FFFFFF 0%, #E8ECFB 100%)'
                      : null
                  }
                  bgColor={skin === 'REWORTH' ? null : 'brand.cardBG'}
                  borderRadius='lg'
                  display='flex'
                  alignItems='center'
                  justifyContent='center'
                  flexDirection='column'
                  h='auto'
                >
                  <BackgroundImage
                    item={value[0]}
                    accentColor={accentColor}
                    fontFamily={fontFamily}
                    skin={skin}
                    greatestCashback={
                      value.length > 1 ? obtainGreatestCashback(value) : null
                    }
                  />
                  <Box w='100%' h='auto' p='1rem'>
                    <Box w='100%'>
                      <Info
                        item={value[0]}
                        fontFamily={fontFamily}
                        skin={skin}
                        isBusiness={1}
                      />
                      <Category
                        lang={lang}
                        item={value[0]}
                        fontFamily={fontFamily}
                        accentColor={accentColor}
                        skin={skin}
                      />
                      <Reward
                        item={value[0]}
                        fontFamily={fontFamily}
                        dictionary={dictionary}
                        skin={skin}
                        isBusiness={1}
                      />
                      <FooterCard
                        item={value[0]}
                        accentColor={accentColor}
                        fontFamily={fontFamily}
                        dictionary={dictionary}
                        skin={skin}
                        setOverlay={(socialMedia, webMedia, val) => {
                          setOverlay(val)
                          setCurrentSocial(socialMedia)
                          setCurrentWeb(webMedia)
                        }}
                        isBusiness={1}
                        businessData={value}
                        // setSelectedBusiness={setSelectedBusiness}
                        setModalType={setModalType}
                      />
                    </Box>
                  </Box>
                </Box>
              </ScaleFade>
            ))}
          </SimpleGrid>
          {/*           {skin === 'CLARA' || skin === 'COPPEL' || skin === 'REWORTH' ? (
            <Paginate
              currentPage={currentPage}
              pagesTotal={pagesTotal}
              accentColor={accentColor}
              handlePagination={(e) => handlePagination(e)}
              skin={skin}
            />
          ) : null} */}
        </Box>
        {/*         {skin === 'COPPEL' && (
          <Show above='lg'>
            <Box
              alignSelf='center'
              onClick={() => handleMoreItems()}
              cursor='pointer'
              paddingLeft='74px'
            >
              <img
                src='https://drive.google.com/uc?export=view&id=12mO5NlmnHfGRjm0qR6NMTe3Td4_Y9Eeb'
                alt='rightArrow'
                width='26px'
                height='87'
              />
            </Box>
          </Show>
        )} */}
      </Box>
    )
  }

  return (
    <Box
      w='100%'
      h='auto'
      mb={['15px', '15px', '15px', '0px']}
      p={
        skin === 'CLARA'
          ? ['1rem 0rem', '1rem 0rem', '2rem 0rem', '1rem 4rem']
          : ['2rem 0rem', '2rem 0rem', '3rem 0rem', '3rem 4rem']
      }
    >
      <Box w='100%'>
        {skin === 'CLARA' ||
        skin === 'COPPEL' ||
        skin === 'INVEX' ||
        skin === 'UNIQ' ||
        skin === 'FINSUS' ||
        skin === 'LIVERPOOL' ||
        skin === 'SUBURBIA' ||
        skin === 'ALBO' 
        ? null : (
          <Heading
            color='brand.secondaryDark'
            fontSize={['xl', '2xl', '3xl', '3xl']}
            fontFamily={fontFamily}
            fontWeight='500'
          >
            {dictionary.CARDS.title}
          </Heading>
        )}
        <Box w='100%' pt={skin === 'CLARA' ? '0rem' : '1rem'}>
          {isLoading && filters.fetchData ? (
            <Box
              w='100%'
              h='60vh'
              display='flex'
              alignItems='center'
              justifyContent='center'
            >
              <Spinner size='xl' color={accentColor} thickness='3px' />
            </Box>
          ) : offersData.length === 0 ? (
            <EmptyCards
              accentColor={skin === 'FINSUS' ? '#23223F' : accentColor}
              dictionary={dictionary}
              fontFamily={fontFamily}
              handleApiConnection={() => {
                skin === 'CLARA' && setSearchName('')
                setFilters({
                  ...filters,
                  category: [],
                  offerType: undefined,
                  priceLevel: undefined,
                  businessType: undefined,
                  fetchData: true,
                  name: undefined
                })
              }}
            />
          ) : (
            <Box>{renderContent()}</Box>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default CardsLayout
